import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { getMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';

type Props = {
  symbol: string;
};

export default function OpenInterest({ symbol }: Props) {
  const { openInterest, priceDecimals, sizeDecimals } = useStore(
    getMarketStore(symbol),
    useShallow((state) => ({
      openInterest: state.marketData.openInterest ?? 0n,
      priceDecimals: state.marketSpec.priceDecimals,
      sizeDecimals: state.marketSpec.sizeDecimals,
    })),
  );
  return formatBigInt(openInterest, priceDecimals + sizeDecimals, {
    digits: 2,
    style: 'currency',
    compact: true,
  });
}

export const openInterestAccessorFn = (symbol: string) => {
  const {
    marketData: { openInterest = 0n },
    marketSpec: { priceDecimals, sizeDecimals },
  } = getMarketStore(symbol).getState();
  return bigIntToNum(openInterest, priceDecimals + sizeDecimals);
};
